import React, { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Users2, TrendingUp, ClipboardList } from "lucide-react";
import GenealogyTree from "@/components/GenealogyTree";

function StatTile({ icon: Icon, label, value, tint = "bg-primary/10 text-primary" }) {
  return (
    <Card className="p-4">
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="text-[11px] text-muted-foreground uppercase tracking-wider">{label}</div>
          <div className="text-2xl font-semibold mt-1">{value ?? 0}</div>
        </div>
        <div className={`w-9 h-9 rounded-full flex items-center justify-center ${tint}`}>
          <Icon className="w-5 h-5" />
        </div>
      </div>
    </Card>
  );
}

export default function MyTeam() {
  const [tree, setTree] = useState(null);
  const load = useCallback(() => {
    api.get("/ibo/my-team")
      .then(({ data }) => setTree(data))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);
  useEffect(() => { load(); }, [load]);

  const teamSize = (tree?.team_size ?? 1) - 1; // exclude self
  const teamBills = tree?.team_bill_count ?? 0;
  const teamParties = tree?.team_party_count ?? 0;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display font-bold text-2xl tracking-tight">My Team</h1>
        <p className="text-sm text-muted-foreground">
          Everyone you recruited plus their downline. You can see all their parties and bills.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatTile icon={Users2} label="Downline size" value={teamSize} tint="bg-emerald-100 text-emerald-700" />
        <StatTile icon={ClipboardList} label="Team parties" value={teamParties} tint="bg-purple-100 text-purple-700" />
        <StatTile icon={TrendingUp} label="Team B2B bills" value={teamBills} tint="bg-blue-100 text-blue-700" />
      </div>

      <GenealogyTree
        roots={tree ? [tree] : []}
        emptyLabel="Your team is empty. Ask Admin to add IBOs under you."
      />
    </div>
  );
}
